<div *ngIf="footer">
  <section class="newsroom_wrapper">
    <div class="container">
      <div class="row">


        <div class="col-md-8">



          <div class="">


            <div (click)="navigate()" class="Display_Flex gap_12 align_item_Center">
              <div>
                <a>
                  <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets/back_arrow_icon.svg"
                    class="width_10px" alt="back_arrow_icon" />
                </a>

              </div>
              <div>
                <span class="infiniteNightText font_Size32 font_Weight600">Newsroom</span>


              </div>

            </div>

            <div class="margin_Bottom34">
              <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets/small_phaserBeamLinebottom.svg"
                [alt]="newsDetail?.news_name ?? 'No Image' " />

            </div>

            <!-- <div class="newsroomOverview_img margin_Bottom16">
              <img [src]="newsDetail?.page?.short_image" alt="yello_card" />
            </div> -->

            <div
              class="Display_Flex align_item_Center justify-content_Spacebetween margin_Bottom16 padding_Bottom12 extraordinary_abundance_bottomborder">
              <div>
                <a class="Display_Flex align_item_Center gap_12">
                  <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets/calendar_icon.svg"
                    alt="calendar_icon" />
                  <span class="phaserBeamText font_Size14 font_Weight600">{{formatDate(newsDetail?.page?.created_at)
                    }}</span>
                </a>

              </div>
              <div>

                <ul class="graySocial_icon">
                  <li>
                    <a target="_blank" href="{{ fb_url }}" class="Display_Flex align_item_Center gap_12">
                      <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets-new/gray_fb.svg"
                        alt="gray_fb" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="{{ twitter_url }}" class="Display_Flex align_item_Center gap_12">
                      <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets-new/gray_x.svg"
                        alt="gray_x" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="{{ mail_url }}" class="Display_Flex align_item_Center gap_12">
                      <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets-new/gray_email.svg"
                        alt="gray_email" />
                    </a>
                  </li>

                  <li>
                    <a target="_blank" href="{{ linked_url }}" class="Display_Flex align_item_Center gap_12">
                      <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets-new/gray_linkedin.svg"
                        alt="gray_linkedin" />
                    </a>
                  </li>
                </ul>


              </div>
            </div>

            <h5 class="font_Size24 font_Weight500 infiniteNightText margin_Bottom12">{{newsDetail?.news_name ?? ''}}
            </h5>
            <div class="newsContentFrame">
              <div [innerHTML]=" newsContent | sanitizer"></div>
            </div>
            <p class="font_Size16 font_Weight400 steelWoolText margin_Bottom12"> </p>


          </div>


        </div>

        <div class="col-md-4">
          <div>
            <h2 class="infiniteNightText font_Size32 font_Weight600">Recent</h2>
            <div class="margin_Bottom34">
              <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets/small_phaserBeamLinebottom.svg"
                alt="small_phaserBeamLinebottom" />

            </div>
            <div>

              <div *ngFor="let news of recentNewsList">
                <div class="recent_news">
                  <h3 (click)="navDetail(news)"
                    class="  font_Size16 font_Weight500 infiniteNightText margin_Bottom12 cursor_Pointer">
                    {{news?.page?.short_content}}
                  </h3>

                  <h4 class="font_Size14 steelWoolText font_Weight500 margin_Bottom16">
                    {{formatDate(news?.page?.created_at)}}</h4>
                </div>
                <div class="extraordinary_abundance_bottomborder margin_Bottom16"></div>

              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="newsroom_blog">
    <div class="container">

      <div class="DeskFlex_Mobileblock justify-content_Spacebetween align_item_Center margin_Bottom34">
        <div>
          <h2 class="font_Size32 infiniteNightText font_Weight700">Blog</h2>
          <div>
            <img src="https://theecode-sayshop.s3.us-west-1.amazonaws.com/pli-assets/small_phaserBeamLinebottom.svg"
              alt="small_phaserBeamLinebottom">
          </div>

        </div>
        <div>
          <button (click)="navBloglist()" class="Mainbutton infiniteNightBtn_clr">Show all</button>
        </div>
      </div>


      <div class="owl-carousel owl-theme blog_owl">
        <div *ngFor="let blog of blogList" class="newsroom_blog_Item">
          <div (click)="navigateBlogDetail(blog.slug)" class="newsroom_blog_img margin_Bottom16">
            <img [src]="blog?.page?.short_image || defaultIMG" [alt]="blog?.blog_name">
          </div>

          <h5 class="font_Size16 font_Weight600 infiniteNightText margin_Bottom12">{{ blog?.blog_name }}</h5>
          <p class="font_Size16 font_Weight400 steelWoolText margin_Bottom12" [innerHTML]="blog?.page?.short_content">
          </p>
        </div>
      </div>
    </div>
  </section>

</div>